import styled from 'styled-components'

export const LoadingIndicatorContainer = styled.div`
    padding-top: 70px;
    padding-bottom: 70px;
`

export const ChartContainer = styled.div`
    margin-top: -24px;
    padding-top: 40px;
`